var _effectorFileName = "/builds/gmini/front-common/src/components/NumCycle/NumCycle.styled.ts";
import { styled } from '@mui/material';
export var NumCircleWrap = styled('span')({
  marginLeft: '5px',
  marginRight: '8px'
});